import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import SvgIcon from '@joinforma/ui/components/SvgIcon';

import { ReactComponent as ArrowLeftSvg } from '@joinforma/ui/assets/icons/arrow-left.svg';

import { SvgIconSize, SvgIconColor } from '@joinforma/ui/constants/properties';

const LinkButton = styled.button`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  width: 100px;
  margin-bottom: 24px;
  background: none;
  border: none;
`;

const TextContainer = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 18.4px;
  color: ${({
    theme: {
      colors: {
        text: { primary },
      },
    },
  }) => primary};
`;

const ArrowLeftIcon = styled(SvgIcon).attrs({
  icon: ArrowLeftSvg,
  size: SvgIconSize.MEDIUM,
  fill: SvgIconColor.PRIMARY,
})`
  margin-top: -1px;
`;

const BackButton = ({
  action,
  text,
  to,
}: {
  action?: () => void;
  text?: string;
  to?: string;
}) => {
  const navigate = useNavigate();

  return (
    <LinkButton
      aria-label={'Go back'}
      type="button"
      onClick={() => {
        if (action) {
          action();
        } else if (to) {
          navigate(to);
        } else {
          navigate(-1);
        }
      }}
    >
      <ArrowLeftIcon />
      {text && <TextContainer>{text}</TextContainer>}
    </LinkButton>
  );
};

export default BackButton;
